export default function () {
  const widgetName = 'footerBG';
  const widgetOpts = footerBGOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function addClass() {

        let winSize = window.screen.width;;

        let bgImage = slide.items[0].ImageWithPath;

        if (winSize <= 400) {
          bgImage = slide.items[1].ImageWithPath;
        }


        $('.hooplandia-footer').css('background-image', `url('${bgImage}')`)

        $(`#${widgetName} .card-widget-item`).each(function () {
          let footerBg = $(this).find('.image-container').attr('data-background-image')
          $(this).find('.card-content').remove()

        })
      }

      addClass()

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: false,
      text: 'Read More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,

  });
}